<template>
<div>
<div v-show="step === 1" class="noLogin">
  <div class="noLogin-top">
    <div class="title">你好，欢迎使用薪必果</div>
    <div class="content">灵活用工专家、共享经济时代引领者</div>
  </div>
  <div class="noLogin-form">
    <div class="iconfont iconshouji shouji"></div>
    <div class="form-input">
      <van-form>
      <van-field
        v-model="formData.mobile"
        placeholder="请输入手机号码"
      />
    </van-form>
    </div>
  </div>
  <div class="noLogin-line">
    <div class="line"></div>
  </div>

  <div class="noLogin-code" @click="sendCode">
    <div class="code">获取验证码</div>
  </div>

</div>
<div v-show="step === 2" class="loginCode">
<!-- <div class="loginCode"> -->
  <div class="iconfont iconzuojiantou jian" @click="goBack">
  </div>
  <div class="loginCode-top">
    <div class="input-code">输入验证码</div>
    <div class="input-code-point">验证码已发送到<span>{{formData.mobile}}</span></div>
  </div>
  <div class="loginCode-form">
    <van-form>
      <van-field
        v-model="formData.smsCode"
        placeholder="请输入手机验证码"
      />
    </van-form>
  </div>
  <div class="sms-code">
    <div class="code"></div>
  </div>
  <div class="loginCode-time">
    <div>验证码已发送<span v-if="count !== 0">({{count}})</span>
      <span v-if="count === 0" style="color:green;font-size:18px;margin-left:5px" @click="sendCode">重新获取</span>
    </div>
    <div>可能会有延迟，请耐心等待...</div>    
  </div>
  <div class="loginCode-register" @click="toLogin">
    <div class="button">登录</div>
  </div>
</div>
</div>

  
</template>
<script>
import http from "../../api/index.js";
import config from "../../utils/config";
import dayjs from 'dayjs';
 const TIME_COUNT = 60;
export default {
  data(){
    return{
      formData:{
        mobile:"", 
        smsCode:"",   
      },
      count: TIME_COUNT,
      disCode: false,
      timer: null,
      step: 1,
      taskNo:"",
    }
  } ,
  mounted(){
    const user_mobile = sessionStorage.getItem('user_mobile');
    if (user_mobile) {
      this.$router.push('/updateInfo')
    }
  },
  methods:{
    sendCode(){
      this.formData.smsCode="";
      if(!this.formData){
        this.$toast.fail("请输入手机号")
      }else{
        http.post(config.sendLoginSms,this.formData).then(({code,data,message})=>{
        const mobile=this.formData.mobile
        if(code===0){
          this.step = 2
          this.timerFun()
        }else{
          this.$toast.fail(message)
        }
      })
      }

    },
    toLogin(){
      if(!this.formData.smsCode){
        this.$toast.fail("请输入手机验证码")
      }else{
        http.post(config.h5Login,this.formData).then(({code,data,message})=>{
        if(code===0 && data.code===200){
          this.taskNo=sessionStorage.getItem("taskNo")
          this.saveVersion();
          if(this.taskNo){
            sessionStorage.setItem('user_mobile', this.formData.mobile)
            http.post(config.scanOrderJump,{taskNo:this.taskNo}).then(({code,data,message})=>{
              if(code===0){
                if(data.code===6201){
                  this.$router.push({path:"../taskDetail"})
                }else if(data.code===6202){
                  location.href=data.signUrl;
                  sessionStorage.removeItem("taskNo")
                }else{
                  this.$router.push({path:"../updateInfo"})
                  sessionStorage.removeItem("taskNo")
                }
              }
            })
          }else{
            sessionStorage.setItem('user_mobile', this.formData.mobile)          
            this.$router.push({path:'/updateInfo'})
          }
        }else{
          this.$toast.fail(message)
        }
      })
      }
    },
    timerFun() {
      // 倒计时
      this.disCode = true;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    goBack(){
      this.step = 1;
    },
    // 登录保存的信息
  saveVersion(){
      http
        .post(config.loginRecord, {
          systemVersion: sessionStorage.getItem("Edition"),
          systemModel: sessionStorage.getItem("Model"),
          loginType:"h5",
          appVersion:"1.0.5",
          // lastLoginTime:new Date().Format("yyyy-MM-dd hh:mm:ss"),
          lastLoginTime:dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
          
        })
        .then((e) => {
          if (e.code == 0) {          
          } else {
          }
        });
    },
  },
  beforeDestroy() {
    if(this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>
<style scoped lang="less">
.noLogin{
  padding: 100px 30px;
  .noLogin-top{
    text-align: left;
    .title{
      font-size: 48px;
    }
    .content{
      font-size: 28px;
    }

  }
  .noLogin-form{
    display: flex;
    align-items: center;
    margin-top: 100px;
    .shouji{
      font-size: 32px;
    }
    .form-input{
    width: 100%;
    }
  }
  .noLogin-line{
    width: 100%;
    display: flex;
    justify-content: center;
    .line{
      width: 100%;
      height: 1px;
      background: #222222;
    }
  }
  .noLogin-code{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 80px;
    .code{
      width: 90%;
      background: #0681FD;
      border-radius: 45px;
      height: 80px;
      font-size: 32px;
      color: #ffffff;
      line-height: 80px;
    }
    
  }

}

.loginCode{
  text-align: left;
  .jian{
    margin-left: 30px;
    padding-top: 30px;
    font-size: 32px;
  }
  .jian{
    font-size: 35px;
  }
  .loginCode-top{
    text-align: left;
    padding:100px 30px;
    .input-code{
      font-size: 48px;
    }
    .input-code-point{
      color: #bbbbbb;
      font-size: 28px;
      span{
        color: #222222;
        margin-left: 10px;
      }
    }

  }
  .loginCode-time{
    font-size: 28px;
    text-align: center;
    .second{
      margin-left: 20px;
      display: inline-block;
    }
  }
  .sms-code{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    .code{
      width: 90%;
      height: 1px;
      background: #222222;
    }
  }
  .loginCode-register{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 80px;
    .button{
      width: 90%;
      height: 80px;
      background: #0681FD;
      line-height: 80px;
      text-align: center;
      color: #ffffff;
      border-radius: 45px;
      font-size: 32px;
    }

  }

}

</style>
<style >
.noLogin .van-cell{
  padding:10px 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/noLogin/index.vue